import {
  CurrencyPipe,
  NgClass,
  NgFor,
  NgIf,
  NgOptimizedImage,
} from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Product } from 'src/app/classes/product';
import { TitleExtractorPipe } from 'src/app/pipe/product-title.pipe';
import { EnvironmentService } from 'src/app/service/environment.service';
import { BadgeComponent } from './badge/badge.component';

@Component({
  selector: 'app-collection-item',
  imports: [
    CurrencyPipe,
    NgIf,
    NgOptimizedImage,
    BadgeComponent,
    NgFor,
    NgClass,
    TitleExtractorPipe,
    RouterLink,
  ],
  templateUrl: './collection-item.component.html',
  styleUrl: './collection-item.component.scss',
})
export class CollectionItemComponent implements OnChanges {
  @Input() product!: Product;
  _related: any;
  constructor(private environmentService: EnvironmentService) {
    this.currency = this.environmentService.environment.currency;
  }
  currency = this.environmentService.environment.currency;

  ngOnChanges(changes: SimpleChanges): void {
    try {
      this._related = JSON.parse(this.product.related || '[]').filter(
        (x: any) => x.hidden !== true
      );
      const match = this._related.find((x: any) => x.id == this.product.id);
      if (match) {
        let group;
        group = this._related.filter((x: any) => x.group == match.group);
        if (group?.length <= 4) {
          group = this._related;
        }
      }
    } catch (err) {
      this._related = [];
    }
  }
}
